export const UI_SET_TITLE = 'UI_SET_TITLE';

export const setTitle = (title = '') => ({
  type: UI_SET_TITLE,
  title
});
